var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c("div", [
        _vm.$mq === "sm" || _vm.$mq === "md" || _vm.$mq === "lg"
          ? _c("div", [
              _c(
                "div",
                { ref: "spotlightSlider" },
                _vm._l(_vm.localArticles, function(article) {
                  return _c("blog-card", {
                    key: article.id,
                    attrs: { article: article }
                  })
                }),
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-[50px]" },
              [
                _vm.localArticles && _vm.localArticles.length
                  ? _c("div", { staticClass: "bg-white" }, [
                      _vm.localArticles[0].acf.image
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "block h-[300px] lg:h-[440px] xl:h-[544px] flex-none",
                              attrs: { href: _vm.localArticles[0].link }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "lazyload w-full h-full object-cover",
                                attrs: {
                                  src: _vm.localArticles[0].acf.image.url,
                                  alt: _vm.localArticles[0].acf.image.alt
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "p-24 lg:px-[61px] lg:py-[41px]" },
                        [
                          _c(
                            "div",
                            { staticClass: "text-14 mb-[5px] font-regular" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.localArticles[0].post_date,
                                    "DD-MM-YYYY"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            { attrs: { href: _vm.localArticles[0].link } },
                            [
                              _c(
                                "h4",
                                {
                                  staticClass:
                                    "text-26 font-bold text-orange mb-24 tracking-normal"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getArticleTitle(_vm.localArticles[0])
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-18 font-regular" }, [
                            _vm._v(_vm._s(_vm.localArticles[0].acf.intro))
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-orange text-16 block mt-8 hover:underline font-medium",
                              attrs: { href: _vm.localArticles[0].link }
                            },
                            [_vm._v("lees meer")]
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "grid grid-cols-1 gap-[41px]" }, [
                  _vm.localArticles && _vm.localArticles.length > 1
                    ? _c(
                        "div",
                        { staticClass: "bg-white flex flex-col lg:flex-row" },
                        [
                          _vm.localArticles[1].acf.image
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "block h-[300px] lg:w-[320px] lg:h-full xl:w-[373px] flex-none",
                                  attrs: { href: _vm.localArticles[1].link }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "lazyload h-full w-full object-cover",
                                    attrs: {
                                      src: _vm.localArticles[1].acf.image.url,
                                      alt: _vm.localArticles[1].acf.image.alt
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "p-24 lg:px-[30px] xl:px-[50px] lg:py-[41px] flex flex-col justify-end"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-14 mb-[5px] font-regular"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.localArticles[1].post_date,
                                          "DD-MM-YYYY"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                { attrs: { href: _vm.localArticles[1].link } },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "text-26 font-bold text-orange mb-24 tracking-normal"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getArticleTitle(
                                            _vm.localArticles[1]
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-18 font-regular" }, [
                                _vm._v(_vm._s(_vm.localArticles[1].acf.intro))
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-orange text-16 block mt-8 hover:underline font-medium",
                                  attrs: { href: _vm.localArticles[1].link }
                                },
                                [_vm._v("lees meer")]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.localArticles && _vm.localArticles.length > 2
                    ? _c(
                        "div",
                        { staticClass: "bg-white flex flex-col lg:flex-row" },
                        [
                          _vm.localArticles[2].acf.image
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "h-[300px] lg:w-[320px] lg:h-full xl:w-[373px] flex-none",
                                  attrs: { href: _vm.localArticles[2].link }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "lazyload h-full w-full object-cover",
                                    attrs: {
                                      src: _vm.localArticles[2].acf.image.url,
                                      alt: _vm.localArticles[2].acf.image.alt
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "p-24 lg:px-[30px] xl:px-[50px] lg:py-[41px] flex flex-col justify-end"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-14 mb-[5px] font-regular"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.localArticles[2].post_date,
                                          "DD-MM-YYYY"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                { attrs: { href: _vm.localArticles[2].link } },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "text-26 font-bold text-orange mb-24 tracking-normal"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getArticleTitle(
                                            _vm.localArticles[2]
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-18 font-regular" }, [
                                _vm._v(_vm._s(_vm.localArticles[2].acf.intro))
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-orange text-16 block mt-8 hover:underline font-medium",
                                  attrs: { href: _vm.localArticles[2].link }
                                },
                                [_vm._v("lees meer")]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }